import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type { LessonPlanCollectionListResponse } from "~/types/admin/content/lesson_plan_collections";

class AdminContentLessonPlanCollectionsModule extends HttpFactory {
  async getLessonPlanCollections(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<LessonPlanCollectionListResponse>> {
    return await this.get(
      `${ENDPOINTS.ADMIN.CONTENT.LESSON_PLAN_COLLECTIONS}`,
      fetchParams,
    );
  }
}

export { AdminContentLessonPlanCollectionsModule };
